export default __webpack_public_path__ + "static/1564-b3a66e6f50a6b314f55824a8efe7c35c.gif";